// The faction ink and the faction word of the three labs: the terrain
// lab, the battle lab and the sonar lab each carried their own copy, and
// `ui/format.ts` re-exports the ink as `cssColor` for the chrome. It is
// a leaf with no sheet, so a pure module of a lab takes it.

import { FACTIONS } from '../gen/balance';
import { factionColor, hex } from '../world';

/** The CSS colour of a faction. */
export function factionInk(f: number): string {
  return hex(factionColor(f));
}

/** The name of a faction, or its number. */
export function factionWord(f: number): string {
  return FACTIONS[f - 1]?.name ?? String(f);
}
